import Vue from 'vue';
import { SUPPLIER } from 'root/blackcard/util/contant';
import { initCardInfo } from 'root/common/init';
import { abTestJson, getABTestSync } from 'root/common/abTest/index';
import ReadTimeParamsPass from 'root/common/util/readTimeParamsPass';
import { onVisibilityChange } from './callApp';
import storage from './storage';
import env from './env';
import { isEqual } from '.';
import { compareVersion, getAppVersion } from './getAppVersion';
import urlUtil from './url';
import { getMiniEnvOfKey } from 'root/common/util/miniEnv';
import StatParamsPass from 'root/common/util/StatParamsPass.js';

const lastPagePvargsKey = 'last-page-pvargs';
let targetStorage = window.sessionStorage;
// app里面sessionStorage会有同步问题，所以使用localStorage
if (env.isApp) targetStorage = window.localStorage;

// 热云
const isAndroid0Package = /ZZCAndroid\/black\/(([0-9]|([1-9]([0-9]*))).){2}([0-9]|([1-9]([0-9]*)))\/qsk0-\w+ /i.test(
    window.navigator.userAgent
);

function getReportKey(eventName) {
    return 'hot-cloud-report-time-' + eventName;
}

function getReportTime(eventName) {
    return Number(window.localStorage.getItem(getReportKey(eventName)));
}

function setReportTime(eventName) {
    window.localStorage.setItem(getReportKey(eventName), String(Date.now()));
}

function shouldReport(eventName) {
    var reportTime = getReportTime(eventName);
    if (!reportTime) return true;
    return Date.now() - getReportTime(eventName) > 30 * 24 * 60 * 60 * 1000;
}

/**
 * 热云埋点
 * @param {string} eventName
 */
export function reportHotCloud(eventName) {
    if (!isAndroid0Package || !shouldReport(eventName)) return;
    document.addEventListener('deviceready', function() {
        try {
            window.zzc.call('trackingIO_setEvent', {
                eventName: eventName,
                extra: '',
                success: console.log,
            });
            setReportTime(eventName);
        } catch (e) {
            console.error(e);
        }
    });
}

// 请求卡号
initCardInfo();

if (!window.$sa_readtime) {
    window.$sa_readtime = {};
}

function getLastHrefToNative() {
    const typeMap = {
        home: 'shouye',
        shop: 'shop',
        privilege: 'vip',
        nearbyGoods: 'home',
        mine: 'mine',
        result: 'page_search',
        selectCity: 'city_page',
    };
    const href = window.location.href;
    const arr = href.match(/#\/([^?]*)/);
    return arr ? typeMap[arr[1]] : href;
}

/**
 * 神策的read time上报逻辑
 * @param {*} e
 */
function readTimeSA() {
    const pageStayListText = window.localStorage.getItem('pageStayList');
    if (!pageStayListText) return;
    window.localStorage.removeItem('pageStayList');
    const pageStayList = JSON.parse(pageStayListText);
    if (!pageStayList.length) return;
    pageStayList.forEach(item => {
        bigTj.track(item.event, item.data);
    });
}

/**
 * 从点击埋点中抽取source_json对象
 * @param {Object} clickTjData
 * @returns
 */
export function getSourceJson(clickTjData) {
    return {
        source_obj_type: clickTjData.obj_type || '',
        source_obj_id: clickTjData.obj_id || '',
        source_item_id: clickTjData.item_id || '',
        source_item_name: clickTjData.item_name || '',
    };
}

const bigTj = {
    _showLogs: [], // 需要在页面展示时上报的数据
    _visibility: true, // 私有属性，请不要乱用
    _lastPagePvargs: null, // 上个页面的page_view
    _pageViewData: null, // 记录当前页面page_view的数据
    pageViewDataMap: new Map(),
    _pageStack: [],
    _pageEnterTime: 0, // 单页模式下记录进入当前单页面的时间戳
    offVisibilityChange: null,
    /**
     * 当前页面page_view的数据，只读属性
     */
    get pageViewData() {
        return { ...this._pageViewData };
    },
    init() {
        if (!this._pageEnterTime) this._pageEnterTime = Date.now();
        this._lastPagePvargs = this.getLastPageParams();
        storage.remove(storage.keys.lastNativePagePvargs);

        this.offVisibilityChange = onVisibilityChange(show => {
            this._visibility = show;
            if (show) {
                if (this._showLogs.length) {
                    // 重新上报缓存的show埋点
                    this._showLogs.forEach(log => this.track(log.event, log.data));
                    this._showLogs = [];
                }
                if (env.isApp) {
                    // app里面如果从其他页面返回当前页面，也视作页面切换
                    // 需要区分是app从后台切换到前台，还是真的页面返回
                    const lastPageData = this.getLastPageParams();
                    if (isEqual(lastPageData, this._pageViewData)) {
                        // 数据相同，说明是后台切前台，不是页面切换
                        // 重置时间
                        this._pageEnterTime = Date.now();
                        return;
                    }
                    // 页面切换
                    readTimeSA();
                    this._lastPagePvargs = lastPageData;
                    storage.remove(storage.keys.lastNativePagePvargs);
                    // 下面的操作是返回页面时，last-page-view修正为当前
                    this.setLastPageParams(this._pageViewData);
                } else {
                    this._pageEnterTime = Date.now();
                }
            } else {
                // 隐藏页面的时候上报一次read time先
                this.trackReadTime();
            }
        });
        StatParamsPass.getParamsFromUrl();
    },
    /**
     * 返回页面可见状态,默认为true
     * @returns {boolean}
     */
    getVisibility() {
        return this._visibility;
    },
    /**
     * 修正可见状态，一般不需要设置，主要是给周边页这种会在后台预加载的页面调用的，因为周边页加载时，页面是不可见状态
     * @param {boolean} visibility
     */
    setVisibility(visibility) {
        this._visibility = visibility;
    },
    /**
     * 在单页路由切换的情况下需要手动触发
     * pageChange要在page_view触发前之前触发，
     * 因为page_view触发的时候还需要更新last-page-pvargs的字段
     * @param {*} pageKey
     */
    pageChange(pageKey) {
        const currentPageKey = this._pageStack[this._pageStack.length - 1];
        if (currentPageKey) {
            // 保存当前页面的page view 数据
            this.pageViewDataMap.set(currentPageKey, this._pageViewData);
        }
        if (!this._pageEnterTime) this._pageEnterTime = Date.now();
        if (this._pageViewData) this._lastPagePvargs = this._pageViewData;
        // 触发read time事件
        this.trackReadTime();
        this._pageStack.push(pageKey);
        const pageData = this.pageViewDataMap.get(pageKey);

        if (pageData) {
            // 设置新的last-page-pvargs
            this.setLastPageParams(pageData);
            window.$sa_readtime.obj_type = pageData.obj_type;
            window.$sa_readtime.obj_id = pageData.obj_id;
        }
    },
    /**
     * 覆盖设置last-page-pvargs
     * @param {*} data
     */
    setLastPageParams(data) {
        if (!data) return;
        const href = getLastHrefToNative();
        // ios1.34.1以及以下版本如果同步给原生，原生会拿来覆盖所有的page_source_type，所以不能同步
        // 只有安卓以及ios大于1.34.1的版本才能同步
        if (env.isAndroid || compareVersion(getAppVersion(), '1.34.1') === 1) {
            storage.set(storage.keys.lastPagePvargs, {
                last_href: href,
                obj_type: data.obj_type,
            });
        } else {
            storage.remove(storage.keys.lastPagePvargs);
        }
        data.href = href;
        this._pageViewData = data;
        targetStorage.setItem(lastPagePvargsKey, JSON.stringify(data));
    },
    /**
     * page_view的时候更新last-page-pvargs中某些字段
     * @param {*} data
     */
    updateLastPageParams(data) {
        const last = this.getSessionLastPagePvargs();
        Object.assign(last, data);
        this.setLastPageParams(last);
    },
    getSessionLastPagePvargs() {
        try {
            const lastPagePVArgs = targetStorage.getItem(lastPagePvargsKey);
            return JSON.parse(lastPagePVArgs) || {};
        } catch (error) {
            return {};
        }
    },
    getLastPageParams() {
        const nativeParams = storage.get(storage.keys.lastNativePagePvargs);
        const h5Params = this.getSessionLastPagePvargs();
        if (nativeParams) {
            if (env.isApp) targetStorage.removeItem(lastPagePvargsKey);
            return nativeParams;
        }
        return h5Params;
    },
    /**
     * 单页切换时触发read time事件
     */
    trackReadTime() {
        // 记录时间
        const now = Date.now();
        const t1 = this._pageEnterTime;
        const t2 = now;
        this._pageEnterTime = now;
        if (t2 - t1 > 0) {
            if (window.$sa_readtime && window.$sa_readtime.obj_type) {
                let params = {
                    obj_id: window.$sa_readtime.obj_id,
                    obj_type: window.$sa_readtime.obj_type,
                    depth: window.$sa_readtime.depth || 0,
                    read_time: t2 - t1,
                    readtime: t2 - t1,
                    ...window.$sa_readtime,
                };

                const readTimeParams = ReadTimeParamsPass.get();
                ReadTimeParamsPass.remove();
                if (readTimeParams) params = Object.assign(readTimeParams, params);
                bigTj.track('readtime', params);
                window.localStorage.removeItem('pageStayList');
                this.fixSensorsDataAutoTrackReadTime();
            }
        }
    },
    /**
     * 页面卸载的时候，修正神策sdk自动缓存的read time数据，
     * 因为调用trackReadTime的时候已经上报过了，避免重复上报
     */
    fixSensorsDataAutoTrackReadTime() {
        // pageStayList的数据格式请看
        // https://h5.chuxingyouhui.com/blackunique/card/js/sensorsdata-20190620.min.js
        const fix = () => {
            const json = window.localStorage.getItem('pageStayList');
            /**@type {Array} */
            const data = json ? JSON.parse(json) : [];
            const readtime = data.find(i => i.event === 'readtime');
            // 重新计算时间
            readtime.data.read_time = Date.now() - this._pageEnterTime;
            window.localStorage.setItem('pageStayList', JSON.stringify(data));
        };
        if (this.cancelFixSensorsDataAutoTrackReadTime) return;
        const event = env.isIos ? 'pagehide' : 'beforeunload';
        window.addEventListener(event, fix);
        // 留个后悔药
        this.cancelFixSensorsDataAutoTrackReadTime = () => window.removeEventListener(event, fix);
    },
    /**
     * 上报埋点
     */
    track: async function() {
        try {
            // 埋点开关
            const sw = await getABTestSync('shopMonitorAb');
            const sa = window.sa;
            // 设置objTypeList
            if (arguments && arguments[1] && Object.prototype.toString.call(arguments[1]) === '[object Object]') {
                arguments[1] = { ...arguments[1] };
                const argsEvent = arguments[0];
                const argsObject = arguments[1];
                // 清除非大数据埋点需要的字段，如gio参数、条件判断参数等
                [
                    'clientTjAction',
                    'clientTjActionData',
                    'gioAction',
                    'gioActionData',
                    'banClick',
                    'banShow',
                    'gioList',
                    'passthroughKeys',
                ].forEach(key => {
                    // eslint-disable-next-line no-prototype-builtins
                    if (argsObject.hasOwnProperty(key)) {
                        delete argsObject[key];
                    }
                });
                const defaultObj = {
                    item_id: '', //元素物件id，没有取""
                    item_name: '', //元素\物件名称，没有取""
                    item_sort: '1', // 元素/物件在模块中的排序位置，从1开始，默认取 1
                    location: '', // 元素/物件的位置，优先取用户自定义标识，没有默认取tab名称，都没有置空，取""
                    location_id: '', // 位置id，默认取""
                    location_sort: '1', // 元素||物件所在位置组件中的排序，从1开始，默认取1
                    page_source_type: '',
                    ...argsObject,
                    sa_login_id: window.localStorage.getItem('member_id') || 0,
                    sa_card_id: window.localStorage.getItem('card_id') || '',
                    login_id: window.localStorage.getItem('member_id') || 0,
                };
                const lastPageParams = this._lastPagePvargs;
                Object.assign(argsObject, defaultObj);
                if (env.isWechatMini) {
                    // 小程序下的虚拟memberId
                    const virtuaMemberId = getMiniEnvOfKey('virtuaMemberId') || 0;
                    if (virtuaMemberId) argsObject.sa_login_id = virtuaMemberId;
                    if (sw === 'B') argsObject.sa_login_id = 0;
                }

                // 记录上一页page_view的统计字段，给read_time埋点用
                if (argsEvent === 'page_view') {
                    let extendParams = {
                        item_id: '',
                        item_name: '',
                        item_sort: '1',
                        location: '',
                        location_id: '',
                        location_sort: '1',
                        ...window.$sa_readtime,
                        obj_href: window.location.href,
                        obj_id: argsObject.obj_id,
                        obj_type: argsObject.obj_type,
                    };
                    // 补充默认字段
                    ['obj_type', 'sa_login_id', 'sa_card_id'].forEach(k => {
                        extendParams[k] = argsObject[k];
                    });
                    this.updateLastPageParams(argsObject);
                    ['depth', 'spu_id', 'goods_category', 'recommend_location'].forEach(key => {
                        if (lastPageParams[key]) extendParams[key] = lastPageParams[key];
                    });

                    extendParams.page_source_type = lastPageParams.obj_type;
                    window.$sa_readtime = extendParams;
                }

                // 修改成所有上报事件都会带上上一页的obj_type来源
                if (lastPageParams) {
                    if (lastPageParams.obj_type) arguments[1].page_source_type = lastPageParams.obj_type;
                    if (lastPageParams.href) arguments[1].last_href = lastPageParams.href;
                }

                // 假如report_stat_params 传 true，则将之前所有透传的字段上报
                if (arguments[1].report_stat_params_pass && typeof arguments[1].report_stat_params_pass === 'boolean') {
                    // 透传埋点
                    const statParamsPassFn = new StatParamsPass({
                        vm: this,
                        isSPA: location.hash ? true : false,
                        isPublicFile: true,
                    });
                    const statParams = statParamsPassFn.getLogSign();
                    arguments[1] = { ...statParams, ...arguments[1] };
                }
                // 假如ab_test_json 传入true,会将ab_test_json上报
                if (arguments[1].ab_test_json && typeof arguments[1].ab_test_json === 'boolean') {
                    arguments[1].ab_test_json = abTestJson();
                }
                // 假如ab_test_json 传入true,会将ab_test_json上报
                if (arguments[1].source_json && typeof arguments[1].source_json === 'boolean') {
                    arguments[1].source_json = getSourceJson(arguments[1]);
                }
                // 补充页面透传埋点数据(因为大数据要传空字符串，但是假如url上没有透传标识就获取不到透传数据，因此需要补充)
                const completeTrackData = updatePageStatParamsPass(arguments[1]);
                arguments[1] = { ...arguments[1], ...completeTrackData };
                Object.keys(arguments[1]).forEach(key => {
                    if (typeof arguments[1][key] === 'object') arguments[1][key] = JSON.stringify(arguments[1][key]);
                });
            }
            if (sa) {
                // 方便调试
                // console.log(JSON.stringify(arguments, null, 2));
                sa.track.apply(this, arguments);
            }
        } catch (error) {
            console.error('埋点出错了', error, arguments);
        }
    },
    /**
     * 上报show或者page_view事件，这个方法会检查当前页面的可见状态，如果页面处于不可见，则会缓存事件，
     * 当页面切换到可见时，才把缓存的事件上报
     * @param {Object} logData
     */
    trackShow(type, logData) {
        try {
            if (this.getVisibility()) {
                this.track(type, logData);
                return;
            }
            this._showLogs.push({ event: type, data: logData });
        } catch (error) {
            console.error('埋点出错了', error, type, logData);
        }
    },
    getTjMallTag: function(id = '', page = 'home') {
        var tag = '';
        // 大于400的supplierID都为自营，22346676为大牌特卖
        if (id != '22346676' && id > 400) id = '4';
        switch (id + '') {
            // 搜索结果「全部」
            case '0':
                tag = 'mall_' + page + '_all';
                break;
            // jd
            case '1':
                tag = 'mall_' + page + '_jingdong';
                break;
            // 严选
            case '3':
                tag = 'mall_' + page + '_yanxuan';
                break;
            // 考拉
            case '2':
                tag = 'mall_' + page + '_kaola';
                break;
            // 自营
            case '4':
                tag = 'mall_' + page + '_ziyin';
                break;
            case '5':
                tag = 'mall_' + page + '_tbk';
                break;
            // 京东粉
            case '7':
                tag = 'mall_' + page + '_jdFan';
                break;
            // 赚客
            case '10':
                tag = 'mall_' + page + '_kaolazhuanke';
                break;
            // 拼多多
            case '11':
                tag = 'mall_' + page + '_pinduoduo';
                break;
            // 唯品会
            case '14':
            case '22':
                tag = 'mall_' + page + '_vip';
                break;
            case '15':
                tag = 'mall_' + page + '_jdFan';
                break;
            case '16':
                tag = 'mall_' + page + '_miniso';
                break;
            case '21':
            case '130':
                tag = 'mall_' + page + '_suning';
                break;
            case '22346676':
                tag = 'mall_' + page + '_vip_temai';
                break;
            case '100':
                tag = 'mall_' + page + '_intl';
        }
        return tag;
    },
    // 商品列表埋点统一处理
    getGoodsListTjData(info, extendTj) {
        let tjData = {
            item_id: info.goodsId || info.jdfSkuId || info.kaolazkSkuId || info.klzkSkuId || info.spuId || '',
            item_name: info.goodsName || info.title || '',
            item_sort: info.sortIndex || 1,
            spu_id: info.goodsId || info.jdfSkuId || info.kaolazkSkuId || info.klzkSkuId || '',
            spu_name: info.goodsName || info.title || '',
            spu_type_name: '',
            spu_lable: info.label || '',
            spu_supplier_fee_lowest: info.originalPrice || '',
            spu_actual_fee_lowest: info.vipPrice || '',
            spu_sort_no: info.sortIndex === undefined ? '' : info.sortIndex,
            supplier_id: info.goodsSourceType || '',
            goods_city: info.provcity || '',
            reserve_price: info.originalPrice || '',
            sale_price: info.vipPrice || '',
            sale_amount: info.volume || info.frontSales || '',
            sku_id: info.skuId || '',
            sku_name: info.skuName || '',
            goods_category: info.goodsTypeId || info.category || '',
            item_lable: info.zeroShopGoods === 1 ? 2 : 1,
            commission_rate: info.rate || info.commissionRate || info.platformCommissionRate || '',
            coupon_id: info.couponId || '',
            coupon_start_time: info.couponStartTime || '',
            coupon_end_time: info.couponEndTime || '',
            coupon_total_count: info.couponTotalCount || '',
            ab_test: info.abTest || info.abTestFlag || '',
            list_name: info.listName || '',
            dsr: info.shopDsr || '',
            ops_request_misc: info.opsRequestMisc || '',
            request_id: info.requestId || '',
            ab_test_page: storage.get('N-newTbAbTest') || 'A',
            page_ab_test: (info.baseCommonResp && info.baseCommonResp.abflag) || '',
            shop_type: '',
            cat_ids: '' || '',
            posi_id: info.posiId || '',
            brand_code: info.brandCode || info.brandId || '',
            brand_name: info.brandName || '',
            comments: '',
            commission: '',
            coupon_amount: '',
            coupon_commission: '',
            coupon_info: '',
            delivery_type: '',
            desc_txt: '',
            good_comments_share: '',
            has_coupon: '',
            has_mall_coupon: '',
            in_order_count_30d: '',
            lgst_txt: '',
            mall_coupon_discount_pct: '',
            mall_coupon_end_time: '',
            service_tags: '',
            serv_txt: '',
            shop_id: '',
            shop_level: '',
            coupon_hot: '',
            ab_test_json: true,
            display_sort_no: '',
            badcase: 0,
            badcase_content: '',
            ...getCatStatDataByItem(info),
            ...getCouponStatDataByItem(info),
            ...getGroupPurchaseDataByItem(info),
            ...getSupplierSpecialParams(info),

            ...extendTj,
        };

        return tjData;
    },
    // 获取商品列表需透传字段
    getGoodsPassOnParams(info, extendTj) {
        const tjData = {
            supplier_id: info.goodsSourceType,
            sku_id: info.skuId || '',
            sku_name: info.skuName || '',
            spu_id: info.goodsId || info.jdfSkuId || info.kaolazkSkuId || info.klzkSkuId,
            spu_name: info.goodsName || info.title || '',
            item_lable: info.zeroShopGoods === 1 ? 2 : 1,
            ab_test: info.abTest || info.abTestFlag || '',
            list_name: info.listName || '',
            goods_category: info.goodsTypeId || info.category || '',
            page_ab_test: (info.baseCommonResp && info.baseCommonResp.abflag) || '',
            posi_id: info.posi_id || '',
            ...getCatStatDataByItem(info),
            ...extendTj,
        };

        return tjData;
    },
};

// 各供应商某些字段特殊处理
export const getSupplierSpecialParams = (info, goodSourceType) => {
    const tjData = {};
    switch (Number(info.goodsSourceType ? info.goodsSourceType : goodSourceType)) {
        case SUPPLIER.tb: {
            tjData.shop_type = info.userType || info.subType || '';

            break;
        }
        case SUPPLIER.jd:
        case SUPPLIER.jdFan:
        case SUPPLIER.jdFake: {
            tjData.comments = info.comments || '';
            tjData.shop_type = info.ownerType || '';
            tjData.brand_code = info.brandCode || info.brandId || '';
            tjData.brand_name = info.brandName || '';
            tjData.in_order_count_30d = info.frontSales || '';
            tjData.delivery_type = info.deliveryType || '';
            tjData.good_comments_share = info.goodCommentsShare || '';
            tjData.commission = info.nativeCommission || '';
            tjData.coupon_commission = info.nativeCouponCommission || '';

            const { shopId, shopLevel, shopName } = info.shopInfo || {};
            tjData.shop_id = shopId || '';
            tjData.shop_level = shopLevel || '';
            tjData.shop_name = shopName || '';

            const formatCouponInfo = {
                coupon_type: '',
                coupon_discount: '',
                coupon_collection_start_time: '',
                coupon_collection_end_time: '',
                coupon_start_time: '',
                coupon_end_time: '',
                coupon_hot: '',
            };
            // 驼峰转换下划线
            // const toLine = name => name.replace(/([A-Z])/g, '_$1').toLowerCase();
            if (info.couponInfoList && info.couponInfoList[0]) {
                const couponInfo = info.couponInfoList[0];
                formatCouponInfo.coupon_type = couponInfo.bindType || '';
                formatCouponInfo.coupon_discount = couponInfo.nativeDiscount || '';
                formatCouponInfo.coupon_collection_start_time = couponInfo.receiveStartTime || '';
                formatCouponInfo.coupon_collection_end_time = couponInfo.receiveEndTime || '';
                formatCouponInfo.coupon_start_time = couponInfo.couponStartTime || '';
                formatCouponInfo.coupon_end_time = couponInfo.couponEndTime || '';
                formatCouponInfo.coupon_hot = '';
            }
            tjData.coupon_info = JSON.stringify(formatCouponInfo);
            Object.keys(formatCouponInfo).map(item => {
                tjData[item] = formatCouponInfo[item];
            });
            break;
        }
        case SUPPLIER.pdd: {
            tjData.shop_type = info.merchantType || '';
            tjData.has_coupon = String(info.hasCoupon) || '';

            const couponInfo = (info.couponInfoList && info.couponInfoList[0]) || {};
            const { hasMallCoupon, mallCouponDiscountPct, mallCouponEndTime } = couponInfo;
            tjData.has_mall_coupon = String(hasMallCoupon || '');
            tjData.mall_coupon_discount_pct = String(mallCouponDiscountPct || '');
            tjData.mall_coupon_end_time = mallCouponEndTime || '';

            const catIds = (info.categoryInfo && info.categoryInfo.catIds) || [];
            tjData.cat_ids = (catIds && catIds.join(',')) || '';
            tjData.cat_id_1st = catIds[0] || '';
            tjData.cat_name_1st = '';
            tjData.cat_id_2nd = catIds[1] || '';
            tjData.cat_name_2nd = '';
            tjData.cat_id_3th = catIds[2] || '';
            tjData.cat_name_3th = '';

            const { descTxt, lgstTxt, servTxt } = info.commentInfo || {};
            tjData.desc_txt = descTxt || '';
            tjData.lgst_txt = lgstTxt || '';
            tjData.serv_txt = servTxt || '';

            tjData.service_tags = (info.serviceTags && info.serviceTags.join(',')) || '';
            tjData.sale_amount = info.volume || info.frontSales || '';
            tjData.goods_sign = info.goodsSign || '';

            break;
        }
    }
    return tjData;
};

/**
 * 与优惠券相关的统计字段
 * @param item
 * @returns {*}
 */
const getCouponStatDataByItem = item => {
    return item.couponInfoList && item.couponInfoList[0]
        ? {
              coupon_id: item.couponInfoList[0].couponeUrl || '',
              coupon_start_time: item.couponInfoList[0].couponStartTime || '',
              coupon_end_time: item.couponInfoList[0].couponEndTime || '',
              coupon_amount: item.couponInfoList[0].couponTotalQuantity || '',
          }
        : {};
};

/**
 * @description: 拼团相关埋点统计字段
 * @param {*} item
 * @return {*}
 */
const getGroupPurchaseDataByItem = item => {
    return item.groupPurchase
        ? {
              activity_id: item.groupPurchaseActivityId,
              group_quantity_number: item.groupPurchaseParticipantNum,
              group_time_limitation: item.groupPurchaseEffectiveLimitTime,
          }
        : {};
};

/**
 * 与分类相关的统计字段
 * @param item
 */
export const getCatStatDataByItem = item => {
    return {
        cat_id_1st: (item.categoryInfo && item.categoryInfo.catId1st) || '',
        cat_name_1st: (item.categoryInfo && item.categoryInfo.catName1st) || '',
        cat_id_2nd: (item.categoryInfo && item.categoryInfo.catId2nd) || '',
        cat_name_2nd: (item.categoryInfo && item.categoryInfo.catName2nd) || '',
        cat_id_3th: (item.categoryInfo && item.categoryInfo.catId3th) || '',
        cat_name_3th: (item.categoryInfo && item.categoryInfo.catName3th) || '',
    };
};

/**
 * @description: 根据路径补全没有透传标识时透传埋点数据
 * @param {*}
 * @return {*}
 */
export const updatePageStatParamsPass = trackData => {
    const trackMap = {
        // 自营商品详情
        '#/detail': {
            ab_test: trackData.ab_test || '',
            recommend_location: trackData.recommend_location || '',
            list_name: trackData.list_name || '',
            ab_test_json: trackData.ab_test_json || true,
            spu_id: trackData.spu_id || urlUtil.getQuery(location.href, { fromHash: true }).goodsId || '',
            supplier_id:
                trackData.supplier_id || urlUtil.getQuery(location.href, { fromHash: true }).goodsSourceType || '',
        },
        // 单品页自营详情
        'topic/views/singleGoods/index.html': {
            ab_test: trackData.ab_test || '',
            recommend_location: trackData.recommend_location || '',
            list_name: trackData.list_name || '',
            ab_test_json: trackData.ab_test_json || true,
            spu_id: trackData.spu_id || urlUtil.getQuery(location.href, { fromHash: false }).goodsId || '',
            supplier_id:
                trackData.supplier_id || urlUtil.getQuery(location.href, { fromHash: false }).goodsSourceType || '',
        },
        // 自营0元购详情
        '#/freeBuy/detail': {
            recommend_location: trackData.recommend_location || '',
            ab_test: trackData.ab_test || '',
            list_name: trackData.list_name || '',
        },
    };
    const currentUrl = window.location.href;
    for (let target in trackMap) {
        if (currentUrl.includes(target)) {
            return trackMap[target];
        }
    }
    return {};
};

Vue.directive('data-tj', {
    inserted: function(element, binding) {
        let tjValue = binding.value;
        console.log('tjValue: ', tjValue);
        if (!tjValue) {
            return;
        }
        element.setAttribute('data-tj', 'true');
        if (typeof tjValue === 'object') {
            //tj:对象
            element.addEventListener('click', function() {
                window.bigTj.track(tjValue.event, {
                    ...tjValue.data,
                });
            });
        } else {
            //tj:字符串
            tjValue = tjValue.split('+');
            element.addEventListener('click', function() {
                window.bigTj.track(tjValue[0], {
                    obj_id: tjValue[1],
                    obj_type: tjValue[2],
                });
            });
        }
    },
    update(element, binding) {
        if (binding.value && !element.getAttribute('data-tj')) {
            element.setAttribute('data-tj', 'true');
            let tjValue = binding.value;
            if (typeof tjValue === 'object') {
                //tj:对象
                element.addEventListener('click', function() {
                    window.bigTj.track(tjValue.event, {
                        ...tjValue.data,
                    });
                });
            } else {
                //tj:字符串
                tjValue = tjValue.split('+');
                element.addEventListener('click', function() {
                    window.bigTj.track(tjValue[0], {
                        obj_id: tjValue[1],
                        obj_type: tjValue[2],
                    });
                });
            }
        }
    },
});

window.bigTj = bigTj;
bigTj.init();

export default bigTj;
